/* tslint:disable: max-line-length */
import { Route, Routes, UrlSegment, UrlSegmentGroup } from '@angular/router';
import { ContentPage } from './components/pages/content.page';
import { SettingsPage } from './components/pages/settings.page';
import { LayoutService } from './services/layout.service';
import { NavigationService } from './services/navigation.service';
import { IntegrationPage } from './components/pages/integration.page';
import { DashboardPage } from './components/pages/dashboard.page';
import { AppWizardComponent } from './components/app-wizard/app-wizard.component';
import { AppMonitoringPage } from './components/pages/app-monitoring.page';
import { WorkflowMonitoringPage } from './components/pages/workflow-monitoring.page';
import { SmartIntegrationControl } from './integration/smartintegration/smart.integration.control';
import { IntegrationControl } from './integration/integrationcontrol/integration.control';

export function CustomSettingsUrlMatcher(segments: UrlSegment[], group: UrlSegmentGroup, route: Route) {
    return segments.length > 0 && segments[0].path === 'settings' ? ({ consumed: segments }) : null;
}

export function CustomSettingsUrlMatcherIntegration(segments: UrlSegment[], group: UrlSegmentGroup, route: Route) {
    return segments.length > 0 && segments[0].path === 'integration' ? ({ consumed: segments }) : null;
}

export function CustomSettingsUrlMatcherDashboard(segments: UrlSegment[], group: UrlSegmentGroup, route: Route) {
    return segments.length > 0 && segments[0].path === 'dashboard' ? ({ consumed: segments }) : null;
}

export const routes: Routes = [
    { component: SettingsPage, matcher: CustomSettingsUrlMatcher },
    { path: 'dashboard', component: DashboardPage, pathMatch: 'full' },
    { path: 'dashboard/app-wizard', component: AppWizardComponent, pathMatch: 'full' },
    { path: 'dashboard/app-monitoring', component: AppMonitoringPage, pathMatch: 'full' },
    { path: 'dashboard/workflow-monitoring', component: WorkflowMonitoringPage, pathMatch: 'full' },
    {
        path: 'integration', component: IntegrationPage, children: [
            { path: 'smartsync', component: SmartIntegrationControl },
            { path: 'data', component: IntegrationControl }
        ]
    },
    {
        path: '**', component: ContentPage, canDeactivate: [() => {
            const disableText = NavigationService.DisableBack.getValue();
            if (disableText) {
                if (LayoutService.PreventBrowserClose.getValue()) {
                    if (confirm(disableText) == false) {
                        history.pushState(null, null, location.href);
                        return false;
                    } else {
                        LayoutService.PreventBrowserClose.next(false);
                        NavigationService.DisableBack.next(null);
                    }
                } else {
                    NavigationService.DisableBack.next(null);
                    if (confirm(disableText) == false) {
                        history.pushState(null, null, location.href);
                        return false;
                    }
                }
            }
            return true;
        }]
    }
];
